import React, { useState } from 'react';

import { Trans } from '@lingui/macro';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Typography } from '@mui/material';

import { LegacyCreateBlockedDialog } from '../../components/LegacyCreateBlockedDialog';
import { Bucket, BucketContainer } from '../../components/sections/bucketSection';
import SpacingContainer from '../../components/sections/spacingContainer';

const BriefPage = () => {
    const [legacyBlockedOpen, setLegacyBlockedOpen] = useState(false);

    return (
        <>
            <BucketContainer isVertical>
                <Bucket sm={12} withDivider={false}>
                    <SpacingContainer justifyContent="center" mt={8}>
                        <Typography variant="h6" color="primary">
                            <Trans>
                                The BRIEF feature was fully implemented in the RFP project creation
                                process. To create a BRIEF, click on &quot;Create new project&quot;
                                in the RFP dashboard!
                            </Trans>
                        </Typography>
                    </SpacingContainer>
                </Bucket>
                <Bucket sm={12}>
                    <SpacingContainer justifyContent="center">
                        <Box
                            sx={{ mr: 1, display: 'inline-block', cursor: 'pointer' }}
                            onClick={() => setLegacyBlockedOpen(true)}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                data-testid="createNewProject"
                                disabled
                                startIcon={<AddIcon />}
                                sx={{ pointerEvents: 'none' }}
                            >
                                <Trans>Create new project</Trans>
                            </Button>
                        </Box>
                    </SpacingContainer>
                </Bucket>
            </BucketContainer>
            <LegacyCreateBlockedDialog
                open={legacyBlockedOpen}
                onClose={() => setLegacyBlockedOpen(false)}
            />
        </>
    );
};

export default BriefPage;
